import type { PropsWithChildren } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";

import { Unauthorized } from "app/views/Unauthorized";

import type { ViewerGateQuery } from "./__generated__/ViewerGateQuery.graphql";

// Blocks the shell for users without system VIEW. whoami needs only LOGIN, so it
// resolves even for them (unlike the shell's platform query), and its
// permissions carry ("system","read") exactly when the user has VIEW.
export function ViewerGate({ children }: PropsWithChildren) {
  const data = useLazyLoadQuery<ViewerGateQuery>(
    graphql`
      query ViewerGateQuery {
        whoami {
          permissions {
            action
            object
          }
        }
      }
    `,
    {},
  );

  const canView = data.whoami.permissions.some(
    (permission) =>
      permission.object === "system" && permission.action === "read",
  );

  return canView ? children : <Unauthorized />;
}
